var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLayers(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8 10.9769L12.9067 7.15689L14 6.31022L8 1.64355L2 6.31022L3.08667 7.15689L8 10.9769ZM7.99333 12.6702L3.08 8.85021L2 9.69021L8 14.3569L14 9.69021L12.9133 8.84354L7.99333 12.6702ZM11.8267 6.31021L8.00006 3.33021L4.17339 6.31021L8.00006 9.29021L11.8267 6.31021Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLayers);
export default __webpack_public_path__ + "static/media/layers.349dd487868f219bbaaf64f7c70ee726.svg";
export { ForwardRef as ReactComponent };